import React from 'react';
import { cn } from '../../lib/utils';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'dark' | 'darker' | 'accent';
}
export function Section({
  children,
  className,
  id,
  background = 'dark'
}: SectionProps) {
  const backgrounds = {
    dark: 'bg-[#0B1A0B]',
    darker: 'bg-[#050D05]',
    accent: 'bg-[#1A2A1A]'
  };
  return <section id={id} className={cn('py-16 md:py-24 px-4 w-full overflow-hidden', backgrounds[background], className)} data-id="element-204">
      <div className="max-w-4xl mx-auto w-full" data-id="element-205">{children}</div>
    </section>;
}